"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specHasUnit = exports.SpecUnitMap = void 0;
exports.SpecUnitMap = {
    fromSpecList: (specList = []) => new Map(specList.map(spec => [spec.SpecCode, spec.SpecValueUnit])),
};
function specHasUnit(spec) {
    return !!spec.SpecValueUnit;
}
exports.specHasUnit = specHasUnit;
